import { PluginHelper, findInLayoutCell, } from "@plansoft-configuration-renderer/layout";
import { SubstructureVariant, } from "../../Controls/Substructure/SubstructureLayout";
import { LayoutControlType } from "../../layouts/LayoutControlType";
/**
 *  Assuming it is an attribute cell, get the variant
 * @param attributeCell
 * @returns
 */
export function isSubconfigurationRenderedAsInstances(attributeCell) {
    const controlCells = findInLayoutCell(attributeCell, (node) => [LayoutControlType.Substructure].includes(PluginHelper.getPluginId(node)));
    // find the variant in the first control cell
    for (const controlCell of controlCells) {
        const variant = PluginHelper.getPluginProps(controlCell).variant;
        return variant === SubstructureVariant.Content;
    }
    // fallback to rendering as attribute
    return false;
}
//# sourceMappingURL=isSubconfigurationRenderedAsInstances.js.map